const o = `<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M3.237,3.26C3.4,2.949,7.548,5.869,9.308,8.382a.176.176,0,0,0,.311-.047c.365-1.117.99-3.922-1.082-5.854C6.7.768,3.268.3,1.385.166A1.279,1.279,0,0,0,.013,1.638C.273,3.506.983,6.9,2.822,8.611A4.59,4.59,0,0,0,6.047,9.837a6.846,6.846,0,0,0,1.711-.231.258.258,0,0,0,.176-.161A.255.255,0,0,0,7.9,9.209C6.486,7.227,3.1,3.519,3.237,3.26Z"
        fill="currentColor" stroke="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="0"></path>
</svg>`;
export {
  o as default
};
